import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { UpdateService } from '@app-types/service.type';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

type Response = { updated: boolean };

const updateService = async (
    id: number,
    data: UpdateService
): Promise<Response> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            `/api/admin/services/${id}`
        );
        const response = await axios.put(endpoint, data, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error updating service:', err);
        return { updated: false };
    }
};

export { updateService };
